import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { catchError, map } from 'rxjs/operators';

import { checkValidResponse, logError } from '@cigna/chcp/shared/util';
import { LatestUpdateRaw, LatestUpdate } from './latest-updates.model';

@Injectable({
  providedIn: 'root',
})
export class LatestUpdatesService {
  public dashboardApi: string;

  public CONSUMER_CODE = '1000';

  constructor(
    private http: HttpClient,
    @Inject('secureApi') secureApi: string,
  ) {
    this.dashboardApi = `${secureApi}/dashboard/v1`;
  }

  getLatestUpdates() {
    const params: HttpParams = new HttpParams().set(
      'consumerCode',
      this.CONSUMER_CODE,
    );
    return this.http
      .get(`${this.dashboardApi}/recentUpdates`, {
        params,
      })
      .pipe(
        map(checkValidResponse),
        map((res) =>
          res.latestUpdates.map(
            (update: LatestUpdateRaw): LatestUpdate => ({
              id: update.id,
              category: update.category,
              subcategeory: update.subcategory,
              title: update.content.item.header,
              date: update.content.item.date,
              content: update.content.item.description,
              linkText: update.content.item.linkText.replace('.', ''),
              imgUrl: update.content.item.imageurl || '',
              videoUrl: update.content.item.videourl || '',
              path: update.content.item.link,
              openExternal: !update.content.item.internal,
              resourceLink:
                update.content.item.link.startsWith('/resourceLibrary') ||
                false,
              appLink: update.content.item.link.startsWith('/app'),
              priority: parseInt(update.metadata.priority, 10),
            }),
          ),
        ),
        catchError(logError),
      );
  }
}
